import { normalize } from 'normalizr'
import { arrayOfCategories } from '../categorySchema'

export default importedCategories => ({ ...normalize(importedCategories, arrayOfCategories) })



// WEBPACK FOOTER //
// ./src/adapters/parsers/importedCategories.js